'use strict';

exports.__esModule = true;
exports.AvatarBox = exports.AVATAR_SIZE_PX = undefined;

var _templateObject = _taggedTemplateLiteralLoose(['\n    width: ', ';\n    height: ', ';\n  '], ['\n    width: ', ';\n    height: ', ';\n  ']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  ', '\n  border-radius: ', ';\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  & img {\n    display: block;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n'], ['\n  ', '\n  border-radius: ', ';\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  & img {\n    display: block;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

// Primitiv-Bibliothek (2026-06): runder Bild-Container <Avatar>.
// Kapselt NUR die runde, geclippte, zentrierte Flaeche (Groessenskala + Rundung +
// overflow + inneres object-fit). Layout (margin, position, ::after-Decor),
// Fallback-Logik (LetterAvatar/Icon), Upload-Overlay und SVG-Innengroesse bleiben
// beim Konsumenten via styled(Avatar) — analog Card: Optik im Primitiv, Layout
// aussen. Token-Aufloesung mit Fallback-Kette analog Card/ButtonStyled (greift nur
// ohne vollstaendigen ThemeProvider).

// Reale Avatar-Groessen der App (Bauplan/Discovery 2026-06): 25 (Header-Dropdown),
// 51 (Chat-Message), 134 (Profil-Uploader). Aktuell migriert ist nur 'lg' (Profil-
// Uploader); sm/md dokumentieren die kanonische Skala fuer kuenftige Adoption.
var AVATAR_SIZE_PX = exports.AVATAR_SIZE_PX = { sm: '25px', md: '51px', lg: '134px' };

var resolveSize = function resolveSize(_ref) {
  var size = _ref.size;

  var px = AVATAR_SIZE_PX[size] || AVATAR_SIZE_PX.md;
  return (0, _styledComponents.css)(_templateObject, px, px);
};

var AvatarBox = exports.AvatarBox = _styledComponents2.default.div(_templateObject2, resolveSize, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadiusRound || '50%';
});